export default __webpack_public_path__ + "static/media/florals.faefc48d.jpg";